var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFormatListNumbered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 23.6673V21.9173H3.41667V21.0423H1.66667V19.2923H3.41667V18.4173H0.5V16.6673H4C4.33056 16.6673 4.60783 16.7793 4.83183 17.0033C5.05506 17.2265 5.16667 17.5034 5.16667 17.834V19.0007C5.16667 19.3312 5.05506 19.6081 4.83183 19.8313C4.60783 20.0553 4.33056 20.1673 4 20.1673C4.33056 20.1673 4.60783 20.2793 4.83183 20.5033C5.05506 20.7265 5.16667 21.0034 5.16667 21.334V22.5007C5.16667 22.8312 5.05506 23.1081 4.83183 23.3313C4.60783 23.5553 4.33056 23.6673 4 23.6673H0.5ZM0.5 15.5007V12.2923C0.5 11.9618 0.612 11.6845 0.836 11.4605C1.05922 11.2373 1.33611 11.1257 1.66667 11.1257H3.41667V10.2507H0.5V8.50065H4C4.33056 8.50065 4.60783 8.61226 4.83183 8.83548C5.05506 9.05948 5.16667 9.33676 5.16667 9.66732V11.709C5.16667 12.0395 5.05506 12.3164 4.83183 12.5397C4.60783 12.7637 4.33056 12.8757 4 12.8757H2.25V13.7507H5.16667V15.5007H0.5ZM2.25 7.33398V2.08398H0.5V0.333984H4V7.33398H2.25ZM7.5 20.1673V17.834H21.5V20.1673H7.5ZM7.5 13.1673V10.834H21.5V13.1673H7.5ZM7.5 6.16732V3.83398H21.5V6.16732H7.5Z",
    fill: "#484D63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFormatListNumbered);
export default __webpack_public_path__ + "static/media/icon_format_list_numbered.6963beb5adee9647e4e52f6ae06cfc1b.svg";
export { ForwardRef as ReactComponent };